import { enqueueSnackbar } from "notistack";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useApiClient } from "../../../api";

export const useAutoGenerateAssignment = () => {
  const ApiClient = useApiClient();
  const navigate = useNavigate();

  const autoGenerateAssignment = async ({
    details,
    onSameAssignment,
    files,
    includesMarkScheme = false,
    singleQuestion = false,
  }) => {
    try {
      const response = await ApiClient.assignment.generateAssignment({
        name: details.name,
        dueDate: dayjs(details.dueDate).format("YYYY-MM-DD"),
        schoolClass: details.schoolClass?.id,
        subject: details.subject?.id,
        files: files,
        includesMarkScheme,
        singleQuestion,
      });

      if (!response.success) {
        enqueueSnackbar(response.message, { variant: "error" });
        return;
      }

      enqueueSnackbar("Assignment is being generated", {
        variant: "success",
        autoHideDuration: 3000,
      });

      if (response.assignment?.id === details?.id) {
        onSameAssignment?.();
      } else {
        navigate(`/assignments/view/${response.assignment.id}`);
      }
    } catch (err) {
      console.log(err);
      enqueueSnackbar("Error submitting, please try again", {
        variant: "error",
      });
    }
  };

  return { autoGenerateAssignment };
};
